export const NOTIFICATION_INSTALLATION_ID_KEY =
  "erp.notifications.installation-id.v1";

function createInstallationId() {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getNotificationInstallationId() {
  const stored = localStorage.getItem(NOTIFICATION_INSTALLATION_ID_KEY);
  if (stored) return stored;

  const installationId = createInstallationId();
  localStorage.setItem(NOTIFICATION_INSTALLATION_ID_KEY, installationId);
  return installationId;
}

export function readNotificationInstallationId() {
  return localStorage.getItem(NOTIFICATION_INSTALLATION_ID_KEY);
}
